<div class="form-domain-script-guide-features-cookie-banner">
    <div class="form-group row" *ngIf="canUseFeature()">
        <label class="col-sm-8 col-form-label text-bold text-right mt-1 pr-0" for="add_cookie_banner" translate>
            Add Acquia Web Governance Consent Manager
        </label>
        <div class="col-sm-40 pl-4">
            <div class="mt-1 d-flex align-items-start">
                <form-field-material-switch
                    id="add_cookie_banner"
                    name="add_cookie_banner"
                    [(ngModel)]="settingEnabled"
                    (ngModelChange)="onEnabledChange($event)">
                </form-field-material-switch>
                <div class="pl-2">
                    <button type="button"
                            (click)="settingEnabled && openConsentManagerScriptSettings()"
                            [disabled]="!settingEnabled"
                            class="btn btn-link button-link-outline"
                            aria-haspopup="true"
                            [ngClass]="{'mon-disabled': !settingEnabled}"
                            translate>
                            Open consent manager script settings
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
